import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from '@app/auth/auth.guard';
import { MainLayoutComponent } from '@app/layout/main-layout/main-layout.component';
import { Roles } from '@models/roles';
import { CommunicationViewerComponent } from './communication-viewer/communication-viewer.component';
import { NotificationLogViewerComponent } from './notification-log-viewer/notification-log-viewer.component';

const routes: Routes = [
  {
    path: 'communication-viewer',
    component: CommunicationViewerComponent,
    canLoad: [AuthGuard],
    data: {
      roles: [Roles.admin, Roles.candidate]
    }
  },
  {
    path: 'notification-log-viewer',
    component: NotificationLogViewerComponent,
    canLoad: [AuthGuard],
    data: {
      roles: [Roles.admin, Roles.candidate]
    }
  },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  }
];

export const DashboardRoutes = RouterModule.forChild(routes);
